import { Box, Tab, Typography } from '@mui/material';
import { t } from 'i18next';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useDataAnalysis } from '@views/pages/DataAnalysis/hooks';
import {
  Submissions,
  WelcomeLetters,
} from '@views/pages/DataAnalysis/components';

export const DataAnalysis = () => {
  const {
    tabIndex,
    handleChangeTab,
    programOptions,
    setWlProgramId,
    wlProgramId,
    organizationOptions,
    wlOrgId,
    setWlOrgId,
    subProgramId,
    subOrgId,
    setSubProgramId,
    setSubOrgId,
  } = useDataAnalysis();
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant='h4' sx={{ mb: 2, mt: 2 }}>
          {t('dataAnalysis.title')}
        </Typography>
      </Box>
      <TabContext value={tabIndex}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={(event, value) => handleChangeTab(value)}>
            <Tab label={t('dataAnalysis.submissions')} value={1} />
            <Tab label={t('dataAnalysis.welcomeLetters')} value={2} />
          </TabList>
        </Box>
        <TabPanel value={1}>
          <Submissions
            organizationOptions={organizationOptions}
            programOptions={programOptions}
            programId={subProgramId}
            orgId={subOrgId}
            setOrgId={setSubOrgId}
            setProgramId={setSubProgramId}
          />
        </TabPanel>
        <TabPanel value={2}>
          <WelcomeLetters
            organizationOptions={organizationOptions}
            programOptions={programOptions}
            programId={wlProgramId}
            orgId={wlOrgId}
            setOrgId={setWlOrgId}
            setProgramId={setWlProgramId}
          />
        </TabPanel>
      </TabContext>
    </>
  );
};
